module.exports = __webpack_public_path__ + "478563586de7f081edb2b57c872dc420.MP3";